export default "__VITE_ASSET__5f6abd6e__"